var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLineUp = function SvgLineUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 110 120"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#7B4EF8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    clipPath: "url(#line-up_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5 115 39.888-53.183c.93-1.242 2.86-.996 3.45.44l8.85 21.548c.584 1.422 2.487 1.68 3.43.466L103.119 25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.283 43.353-3.123-17.72a2 2 0 0 0-2.317-1.622l-17.72 3.124"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "line-up_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h110v120H0z"
  })))));
};
export default SvgLineUp;